import type { User } from "@/context/AuthContext";
import { AlertDialog, AlertDialogContent, AlertDialogDescription, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { useState, type FormEvent } from "react";
import { lensburyFetch } from "@/lib/utils";
import { Field, FieldGroup, FieldLabel } from "@/components/ui/field";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertCircleIcon } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/ui/spinner";

export interface LoginProps {
  onLogin?: () => void,
};

export function LoginOverlay({ onLogin }: LoginProps) {
  const [error, setError] = useState<Error | undefined>(undefined);
  const [loading, setLoading] = useState<boolean>(false);
  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    setLoading(true);
    e.preventDefault();
    const formData = Object.fromEntries(new FormData(e.currentTarget).entries());
    lensburyFetch("POST", "/login", formData).then((res) => {
      setLoading(false);
      onLogin!();
    }).catch(setError);
  };
  return (
    <AlertDialog open={!!onLogin}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Login Required</AlertDialogTitle>
          <AlertDialogDescription>Please enter your <b>Lensbury</b> email and password to continue.</AlertDialogDescription>
        </AlertDialogHeader>
        <form onSubmit={onSubmit}>
          <FieldGroup className="gap-4">
            {error && <Alert variant="destructive" className="max-w-md">
              <AlertCircleIcon />
              <AlertTitle>Login failed</AlertTitle>
              <AlertDescription>{error.message}</AlertDescription>
            </Alert>}
            <Field className="gap-2">
              <FieldLabel htmlFor="email">Email</FieldLabel>
              <Input id="email" name="username" type="email" required />
            </Field>
            <Field className="gap-2">
              <FieldLabel htmlFor="password">Password</FieldLabel>
              <Input id="password" name="password" type="password" required />
            </Field>
            <Field className="mt-2">
              <Button type="submit">
                {loading && <Spinner data-icon="inline-start" />}
                Login
              </Button>
            </Field>
          </FieldGroup>
        </form>
      </AlertDialogContent>
    </AlertDialog>
  );
}
